import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "gas",
  "use": "gas-usage",
  "viewBox": "0 0 11 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 16\" id=\"gas\"><title>gas</title><path d=\"M9.143 13.943C7.467 16 4.724 16 4.724 16c3.048-3.048-.457-6.4-.457-6.4s-3.2 3.276 0 6.4c0 0-2.971-.076-3.886-2.59C-1.981 7.162 7.619 6.629 3.429 0c.533.076 2.133.533 4.267 2.819 3.048 3.276 4.19 7.771 1.448 11.124z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/gas.svg
// module id = 521
// module chunks = 0